<template lang="pug">
  .b-change Задача отредактирована
</template>

<script>
export default {
  name: 'TaskChangeDescription',
  props: {
    change: Object,
  },
};
</script>

<style scoped lang="scss">

</style>
